import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown w-md-650px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "px-7 py-5 row" }
const _hoisted_3 = { class: "fs-5 text-dark fw-bolder col-3" }
const _hoisted_4 = { class: "d-flex justify-content-end col-9" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_8 = { class: "px-7 py-5 row" }
const _hoisted_9 = { class: "mb-10 col-3" }
const _hoisted_10 = { class: "fs-7 form-label fw-bold" }
const _hoisted_11 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 mb-5" }
const _hoisted_12 = { class: "form-check-label user-select-none" }
const _hoisted_13 = { class: "form-check form-check-sm form-check-custom form-check-solid mb-5" }
const _hoisted_14 = { class: "form-check-label user-select-none" }
const _hoisted_15 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_16 = { class: "form-check-label user-select-none" }
const _hoisted_17 = { class: "fs-7 form-label fw-bold mt-10" }
const _hoisted_18 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 mb-5" }
const _hoisted_19 = { class: "form-check-label user-select-none" }
const _hoisted_20 = { class: "form-check form-check-sm form-check-custom form-check-solid mb-5" }
const _hoisted_21 = { class: "form-check-label user-select-none" }
const _hoisted_22 = { class: "mb-10 col-3" }
const _hoisted_23 = { class: "fs-7 form-label fw-bold" }
const _hoisted_24 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 mb-5" }
const _hoisted_25 = { class: "form-check-label user-select-none" }
const _hoisted_26 = { class: "form-check form-check-sm form-check-custom form-check-solid mb-5" }
const _hoisted_27 = { class: "form-check-label user-select-none" }
const _hoisted_28 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_29 = { class: "form-check-label user-select-none" }
const _hoisted_30 = { class: "fs-7 form-label fw-bold mt-10" }
const _hoisted_31 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5 mb-5" }
const _hoisted_32 = { class: "form-check-label user-select-none" }
const _hoisted_33 = { class: "form-check form-check-sm form-check-custom form-check-solid mb-5" }
const _hoisted_34 = { class: "form-check-label user-select-none" }
const _hoisted_35 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_36 = { class: "form-check-label user-select-none" }
const _hoisted_37 = { class: "mb-10 col-6" }
const _hoisted_38 = { class: "form-label fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("filters")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args))),
          type: "reset",
          class: "btn btn-sm btn-white btn-active-light-primary me-2",
          "data-kt-menu-dismiss": "true",
          disabled: 
            _ctx.filterDate.length == 0 &&
            _ctx.haveFilter == false &&
            _ctx.filtersChanged == false
          
        }, _toDisplayString(_ctx.$t("deleteFilters")), 9, _hoisted_5),
        _createElementVNode("button", {
          type: "submit",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setFilters && _ctx.setFilters(...args))),
          class: "btn btn-sm btn-primary",
          "data-kt-menu-dismiss": "true",
          disabled: 
            _ctx.filterDate.length == 0 ||
            (_ctx.actualDate == _ctx.filterDate &&
              !Array.isArray(_ctx.filterDate) &&
              _ctx.filtersChanged == false)
          
        }, _toDisplayString(_ctx.$t("ok")), 9, _hoisted_6)
      ])
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("typeVictim")), 1),
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              value: 1,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.victimTypeIds) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.filters.victimTypeIds]
            ]),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("distressVictim")), 1)
          ]),
          _createElementVNode("label", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              value: 2,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.victimTypeIds) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.filters.victimTypeIds]
            ]),
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("activeVictim")), 1)
          ]),
          _createElementVNode("label", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              value: 3,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.victimTypeIds) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.filters.victimTypeIds]
            ]),
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("passiveVictim")), 1)
          ])
        ]),
        _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("others")), 1),
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              value: 1,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.victimsToHospital) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.filters.victimsToHospital]
            ]),
            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("onlyHospitalized")), 1)
          ]),
          _createElementVNode("label", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              value: true,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.jetSkiInvolved) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.filters.jetSkiInvolved]
            ]),
            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("onlyWithJetSki")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("typeCause")), 1),
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_24, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              value: 1,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.incidentCauseIds) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.filters.incidentCauseIds]
            ]),
            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("currentRescue")), 1)
          ]),
          _createElementVNode("label", _hoisted_26, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              value: 2,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.incidentCauseIds) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.filters.incidentCauseIds]
            ]),
            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("exhaustionRescue")), 1)
          ]),
          _createElementVNode("label", _hoisted_28, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              value: 3,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.incidentCauseIds) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.filters.incidentCauseIds]
            ]),
            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("others")), 1)
          ])
        ]),
        _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("typeIncident")), 1),
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_31, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              value: 2,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filters.incidentTypeIds) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.filters.incidentTypeIds]
            ]),
            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("surfAccident")), 1)
          ]),
          _createElementVNode("label", _hoisted_33, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              value: 3,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filters.incidentTypeIds) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.filters.incidentTypeIds]
            ]),
            _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("bathingAccident")), 1)
          ]),
          _createElementVNode("label", _hoisted_35, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              value: 1,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filters.incidentTypeIds) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.filters.incidentTypeIds]
            ]),
            _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t("others")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("dates")), 1),
        _createVNode(_component_Datepicker, {
          modelValue: _ctx.filterDate,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filterDate) = $event)),
          minDate: _ctx.minDate,
          maxDate: 
            _ctx.maxDate == null
              ? new Date()
              : _ctx.maxDate < new Date()
              ? _ctx.maxDate
              : new Date()
          ,
          autoRange: 6,
          enableTimePicker: false,
          startTime: [
            { hours: 0, minutes: 0, seconds: 0 },
            { hours: 23, minutes: 59, seconds: 59 },
          ],
          range: "",
          inline: "",
          autoApply: ""
        }, null, 8, ["modelValue", "minDate", "maxDate"])
      ])
    ])
  ]))
}